import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/ui/LoadingSpinner';

export default function SignIn() {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (!loading && isAuthenticated) {
      navigate('/dashboard');
      return;
    }

    // Only initiate sign in if not authenticated
    if (!loading && !isAuthenticated) {
      const initiateSignIn = async () => {
        try {
          await signInWithRedirect();
        } catch (error) {
          console.error('Sign in redirect error:', error);
        }
      };
      
      initiateSignIn();
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-8">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-600">
          {loading ? 'Checking authentication...' : 'Redirecting to sign in...'}
        </p>
      </div>
    </div>
  );
}
